import { useEffect, useState } from "react";
/*
  Delayed loader showing, this helps UX by not flashing loaders for things that load quickly

  The ms we decided on was based on the research here: https://www.nngroup.com/articles/response-times-3-important-limits/
  TLDR: 100ms is breakpoint for something to be percieved by the average person as not instant/connected to their input.
  */ export function useLoaderDelay() {
    const [showLoader, setShowLoader] = useState(false);
    useEffect(()=>{
        /*
      One more note: we give a 25ms window for the animation to have time to spin up, want to start giving
      that feedback before we hit that 100ms breakpoint
    */ const timeout = setTimeout(()=>setShowLoader(true), 75);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        setShowLoader
    ]);
    return showLoader;
}
